import ItodoImage from "../../../elements/itodo-img";
import { neuronMedia } from "../../../../globals/neuron-content";

function SectionComments({ commentUrl = "/insights#comments" }) {
  return (
    <>
      <div className="clear comment-section-outer" id="comment-list">
        <div className="comments-area" id="comments">
          <h2 className="comments-title m-b30">Comments<span>(02)</span></h2>
          <div className="comments-outer p-b30">
            <ol className="comment-list">
              <li className="comment">
                <div className="comment-body">
                  <div className="comment-author vcard">
                    <ItodoImage className="avatar photo" src={neuronMedia.gallery[0]} alt="comment" />
                    <cite className="fn">By: Operations Manager, Infrastructure Program</cite>
                  </div>
                  <div className="comment-meta">
                    <a href={commentUrl}><i className="fa fa-calendar" />21 April 2026</a>
                  </div>
                  <p>Useful breakdown. The emphasis on route alternatives and communication checkpoints is exactly what teams need before live movement days.</p>
                  <div className="reply">
                    <a href={commentUrl} className="comment-reply-link">Reply <i className="fa fa-long-arrow-right" /></a>
                  </div>
                </div>
                <ol className="children">
                  <li className="comment odd parent">
                    <div className="comment-body">
                      <div className="comment-author vcard">
                        <ItodoImage className="avatar photo" src={neuronMedia.gallery[4]} alt="comment" />
                        <cite className="fn">By: Neuron Editorial Desk</cite>
                      </div>
                      <div className="comment-meta">
                        <a href={commentUrl}><i className="fa fa-calendar" />22 April 2026</a>
                      </div>
                      <p>Thanks for sharing. We will also publish a short checklist format teams can use before high-priority executive movements.</p>
                      <div className="reply">
                        <a href={commentUrl} className="comment-reply-link">Reply <i className="fa fa-long-arrow-right" /></a>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
            <div className="comment-respond m-t30" id="respond">
              <h2 className="comment-reply-title m-b30" id="reply-title">Leave a Reply</h2>
              <p>Share your question or practical field insight. Required fields are marked *</p>
              <form className="comment-form row" id="commentform" method="post">
                <p className="comment-form-author col-lg-6 col-md-6">
                  <label htmlFor="author">Your Name <span className="required">*</span></label>
                  <input className="form-control" type="text" defaultValue={""} name="user-comment" placeholder="Your Name *" id="author" />
                </p>
                <p className="comment-form-email col-lg-6 col-md-6">
                  <label htmlFor="url">Phone Number</label>
                  <input className="form-control" type="text" defaultValue={""} name="url" placeholder="Phone Number" id="url" />
                </p>
                <p className="comment-form-url col-lg-12 col-md-12">
                  <label htmlFor="email">Email <span className="required">*</span></label>
                  <input className="form-control" type="text" defaultValue={""} name="email" placeholder="Your Email *" id="email" />
                </p>
                <p className="comment-form-comment col-lg-12 col-md-12">
                  <label htmlFor="comment">Comment</label>
                  <textarea className="form-control" rows={8} name="comment" placeholder="Your Comment" id="comment" defaultValue={""} />
                </p>
                <p className="comment-form-cookies-consent"><input id="wp-comment-cookies-consent" name="wp-comment-cookies-consent" type="checkbox" defaultValue="yes" /><label htmlFor="wp-comment-cookies-consent">Save my details in this browser for the next comment.</label></p>
                <p className="form-submit">
                  <button type="button" className="site-button sx-btn-primary icon sx-btn-lg"><i className="fa fa-long-arrow-right" /> Post Comment </button>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionComments;
